import { connect } from "react-redux";
import { withRouter } from "react-router";
import WIAuthorSteps from './WIAuthor/WIAuthorSteps'

import {  saveWorkInstruction, editWorkInstruction} from '../../../../redux/actions/wi_actions'
import { updateUserStepsDone } from '../../../../redux/actions/user_actions'


const mapStateToProps = (state, ownProps) => {
    let currentUser = null;
    if (state.session?.user) {
        const uid = state.session.user._id;
        if (state.users && state.users[uid]) {
            currentUser = state.users[uid];
        } else {
            // Fallback to the user data stored in session (in case users slice not populated yet)
            currentUser = state.session.user;
        }
    }

    return { 
        workInstruction: state.author,
        workInstructions: state.work_instructions.all,
        isLiteView: ownProps.isLiteView,
        user: currentUser, // user object from users slice or session fallback
    };
}

const mapDispatchToProps = (dispatch, ownProps) => {
    let wip_ID = ""

    if (typeof ownProps.wip_ID != "undefined" && ownProps.wip_ID !== null){
        wip_ID = ownProps.wip_ID
    }
    else{
        wip_ID = ownProps.location.pathname.split('/').pop()
    }
    return ({
        updateWorkInstruction: updatedWorkInstruction => dispatch(saveWorkInstruction(updatedWorkInstruction)),
        editWorkInstruction: (() => dispatch(editWorkInstruction(wip_ID))),
        updateUserStepsDone: (payload) => dispatch(updateUserStepsDone(payload)),
        //addTab: (()=>dispatch(ownProps.addTab(title,wip_ID)))
    });
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WIAuthorSteps));
